
import { cpf, cnpj } from 'cpf-cnpj-validator';
import filesize from 'file-size';

export const validCnpjCpf = (cpfCnpj: string) => {
  if (cpfCnpj.length <= 14) {
    return cpf.isValid(cpfCnpj);
  } else if (cpfCnpj.length == 18) {
    return cnpj.isValid(cpfCnpj);
  }
}

export const validCpf = (cpfNumber: string): boolean => {
  return cpf.isValid(cpfNumber);
}

export const validCnpj = (cnpjNumber: string): boolean => {
  return cnpj.isValid(cnpjNumber);
}

export const validSizeFile = (maxSize: number) => (fileList: any, ctx: any): boolean => {
  if (Array.isArray(fileList)) {
    return fileList.length == 0 || ![...fileList].find((file: any) => Number(filesize(file.size).to('MB')) > maxSize)
  }
  return true
}
